import React from 'react';
import { connect } from 'react-redux';
import { contentMaskSelector } from './selector';
import { contentMaskHideAction } from './actions';

const mapStateToProps = (state) => ({
  show: contentMaskSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
  hideMask: () => dispatch(contentMaskHideAction()),
});

export const ContentMask = connect(
  mapStateToProps,
  mapDispatchToProps
)(({ show, hideMask }) => (show ? <div className="ct-content-mask" onClick={hideMask} /> : null));
